<template>
  <div>

    <section class="results" v-if="new_costs">
      <div class="">
        <div class="results__table" v-if="new_costs" style="overflow: visible !important;">
          <table>
            <tr>
              <td class="noStyle"></td>
              <td colspan="7" class="highlightRow">
                your potential savings
                <span v-if="quote.machines_amount > 1" style="font-size: inherit; font-weight: inherit;">when opting for full fleet:</span>
                <span v-html="new_costs && new_costs[0] ? mnwp(maxSavingOverTerm(results.new_costs[0])) : 'N/A'" style="font-size: inherit; font-weight: inherit;"></span>
              </td>
            </tr>
            <tr>
              <th class="noStyle"></th>
              <th>&nbsp; <br> manufacture and model<br>&nbsp;</th>
              <th>speed (letters per minute)  </th>
              <th>envelope thickness capacity</th>
              <th>standard scale capacity</th>
              <th>service/maintenance offering</th>
              <th>quick view product rating</th>
              <th>YOUR POTENTIAL SAVINGS ON NEW TERM</th>
            </tr>
            <tbody>
            <tr>
              <td class='rotate blue' rowspan="1">
                <div style="font-size:25px;">current</div>
              </td>
              <td class="image">
                <img :src="printerImage(current_costs.printer.image_url)" v-if='current_costs && current_costs.printer' :class="{'stamps' : current_costs.printer.id == 1}"/>
                <div>
                  {{ current_costs && current_costs.printer ? current_costs.printer.manufacturer.name : ''}}
                  <br/>
                  {{ current_costs && current_costs.printer ? current_costs.printer.model : '' }}
                </div>
              </td>
              <td class="innerTable">
                <table>
                  <tr>
                    <td>
                      <h6>Standard</h6>
                      {{ current_costs && current_costs.printer ? current_costs.printer.speed_standard : 0 }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>Auto size and weight</h6>
                      {{ current_costs && current_costs.printer ? current_costs.printer.auto_size_weight : 0 }}
                    </td>
                  </tr>
                </table>
              </td>
              <td>{{ current_costs && current_costs.printer ? current_costs.printer.envelope_thickness_capacity : 0 }}</td>
              <td>{{ current_costs && current_costs.printer ? current_costs.printer.scale_capacity : 0 }}</td>

              <td v-if="(current_costs && current_costs.printer) && current_costs.printer.model === 'Stamps'">N/A</td>
              <td v-else>AS PER EXISTING</td>

              <td>{{ current_costs ? current_costs.rating : 0 }}/{{ results ? results.max_rating : 0 }}</td>
              <td class="largeText blue">N/A</td>
            </tr>

            <fragment v-for="costs, index in new_costs" v-if="new_costs && !costsHasError(costs)" :key="index">

              <tr v-if="!costsHasError(costs)">
                <td class='rotate red' rowspan="1">
                  <div style="font-size:25px;">proposed</div>
                </td>
                <td class="image">
                  <img :src="printerImage(costs.printer.image_url)" v-if='costs.printer'/><br>
                  {{ costs.printer ? costs.printer.manufacturer.name : '' }}
                  <br/>
                  {{ costs.printer ? costs.printer.model : '' }}
                </td>
                <td class="innerTable">
                  <table>
                    <tr>
                      <td>
                        <h6>Standard</h6>
                        {{ costs.printer ? costs.printer.speed_standard : 0 }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h6>Auto size and weight</h6>
                        {{ costs.printer ? costs.printer.auto_size_weight : 0 }}
                      </td>
                    </tr>
                  </table>
                </td>

                <td>{{ costs.printer ? costs.printer.envelope_thickness_capacity : 0 }}</td>
                <td>{{ costs.printer ? costs.printer.scale_capacity : 0 }}</td>
                <td>{{ costs.printer ? costs.printer.service_name : '-' }}</td>
                <td>{{ costs.printer ? costs.rating : 0 }}/{{ results ? results.max_rating : 0 }}</td>
                <td class="largeText red">
                  <span
                    style="white-space: nowrap;"
                    v-html="costs ? mnwp(maxSavingOverTerm(costs)) : 'N/A'"></span>
                </td>
              </tr>
            </fragment>

            </tbody>
          </table>
        </div>

        <div class="dashboard-results-comparison">
          <table v-for="costs, index in new_costs" v-if="new_costs && !costsHasError(costs)" :key="index">
            <more-info-tr
              @progress-with-order="(investment_option) => onProgressWithOrder(investment_option, quote, costs, additionalOptions, current_costs)"
              :quote="quote"
              :new_costs="costs"
              :current_costs="current_costs"
              :model="costs.printer"
              :service_upgrade="additionalOptions.service_upgrade"
              :quote_confirmation="additionalOptions.quote_confirmation"
              v-if="costs.printer"></more-info-tr>
          </table>
        </div>

      </div>
    </section>

  </div>
</template>
<script>
  import MoreInfo from './Partials/SummaryMoreInfo.vue'

  export default {
    components: {
      'more-info-tr': MoreInfo,
    },
    created() {
      this.quote_id = this.$route.params.id
      this.loadResults()
    },
    data() {
      return {
        showMoreInfo: null,
        showMoreInfoCache: null,
        loading: true,
        quote_id: null,
        quote: null,
        additionalOptionsOpen: false,
        results: {
          table1: {},
          letters: null,
          packets: null,
          total: null,
          models: {},
          printer_model: null,
        },
        new_costs: null,
        current_costs: null,
        watchAdditionalOptions: true,
        additionalOptions: {
          lease_option_1: null,
          lease_option_2: null,
          quote_confirmation: null,
          packets_capacity: null,
          accounts_amount: null,
          feeder_type: null,
          engineer_installation_training: null,
          differential_weighting: null,
          logo_and_return_address: null,
          business_mail_advanced: null,
          connectivity: null,
          postage_payment: null,
          inbound_courier_parcel_tracking_cost: null,
          outbound_shipping_application: null,
          service_upgrade: null,
        },
        singlePrinterOptions: {},
        topModal: null,
        enabledManufacturers: {
          2: true,
          3: true,
          4: true,
          5: true,
        }

      }
    },
    watch: {
      additionalOptions: {
        handler() {
          if (this.watchAdditionalOptions) {
            this.cacheShowMoreInfo()
            this.loadResults()
          }
          this.watchAdditionalOptions = true
        },
        deep: true
      }
    },
    methods: {
      costsHasError(costs) {
        if (costs.postage_payment_arrears_warning) return true
        if (costs.departmental_accounting_not_found) return true
        if (costs.scale_cost_machine_not_found) return true
        if (costs.differential_weighting_not_found) return true
        if (costs.business_mail_advanced_not_found) return true
        if (costs.connectivity_not_found) return true
        if (costs.inbound_courier_parcel_tracking_cost_not_found) return true
        if (costs.outbound_shipping_application_not_found) return true
        if (costs.service_upgrade_not_found) return true
        if (costs.comparable_model_not_found) return true
        if (costs.feeder_type_not_found) return true
        return false
      },
      loadResults(ignoreAdditionalOptions = false) {

        let params = {};
        if (!ignoreAdditionalOptions) {
          params = {
            additionalOptions: this.additionalOptions,
            singlePrinterOptions: this.singlePrinterOptions,
          }
        }

        this.axios.get('/quotes/results/' + this.quote_id, {params}).then(response => {
          this.new_costs = false
          this.$nextTick(() => {
            this.results = response.data.results
            this.current_costs = response.data.results.current_costs
            this.new_costs = response.data.results.new_costs
            this.loading = false
            this.quote = response.data.results.quote

            this.showMoreInfo = this.showMoreInfoCache || this.showMoreInfoCache === 0 ? this.showMoreInfoCache : null
            this.showMoreInfoCache = null

            this.watchAdditionalOptions = false
            this.additionalOptions = response.data.additionalOptions || {}
          })
        }).catch(err => {
        })
      },
      toggleMoreInfo(id) {
        let valueToShow = this.showMoreInfo === id ? null : id
        this.showMoreInfo = null
        this.$nextTick(() => {
          this.showMoreInfo = valueToShow
        })
      },
      toggleManufacturer(id) {
        let new_costs_temp = {}
        Object.assign(new_costs_temp, this.new_costs)
        this.new_costs = false
        this.showMoreInfo = null
        this.$nextTick(() => {
          this.enabledManufacturers[id] = !this.enabledManufacturers[id]
          this.new_costs = new_costs_temp
          this.showMoreInfo = null
        })
      },

      printerImage(image_url = false) {
        if (image_url)
          return '/static/styles/mailkit/img/printers/' + image_url
        return 'http://placehold.it/195x195'
      },
      cacheShowMoreInfo() {
        this.showMoreInfoCache = this.showMoreInfo
      },

      resetFilters() {
        this.cacheShowMoreInfo()
        this.loadResults(true)
      },

      onProgressWithOrder(investment_option, quote, costs, additional_options, current_costs) {

        this.axios.post('orders', {investment_option, quote, costs, additional_options, current_costs}).then(response => {
          let order_id = response.data.id
          this.$router.push({name: 'orders.index', params: {id: order_id}})
        }).catch(err => {
          console.log(err)
        })
      },

      mnwp(number) {
        if (number < 0) {
          return '-&pound;' + _n(Math.abs(number))
        }
        return '&pound;' + _n(number)
      },
      maxSavingOverTerm(costs) {
        let options = [
          parseFloat(costs.effective_annual_saving.lease[this.additionalOptions.lease_option_1 - 1].toFixed(2)),
          parseFloat(costs.effective_annual_saving.lease[this.additionalOptions.lease_option_2 - 1].toFixed(2)),
        ]
        if (this.additionalOptions.quote_confirmation) {
          options.push(
            parseFloat(costs.saving_over_term.purchase.toFixed(2))
          )
        }
        return _.max(options)
      },
      getReadableFeederType(type) {
        if (type === 'hand') return 'Hand feeder'
        if (type === 'auto') return 'Automatic feeder'
        if (type === 'full_auto') return 'Fully automatic feeder'
      }

    }
  }
</script>
<style>
  td.image img {
    width: 195px;
    height: auto;
  }

  img.stamps {
    width: 100px !important;
  }

  .red-text {
    font-size: 18px;
    color: #b50a78;
    font-weight: bold;
  }

  .blue-text {
    font-size: 18px;
    color: #2B72DC;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/ProposalTemplate/Summary.vue